// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresGuestRemoveBody = {
  poolId: string;
  guestId: string;
};

export type typeSquaresGuestRemoveOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { guestId: string; releasedSquareCount: number };
};

export type typeSquaresGuestRemoveOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGuestRemoveOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGuestRemoveOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresGuestRemoveBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    guestId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "guestId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresGuestRemove(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresGuestRemoveBody);
  }

  return async function postSquaresGuestRemove(
    payload: typeSquaresGuestRemoveBody,
  ): Promise<
    typeSquaresGuestRemoveOutput200 | typeSquaresGuestRemoveOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresGuestRemove" failed before calling the network. #d9e2461428d1`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d9e2461428d1" },
        },
        data: null,
      } as typeSquaresGuestRemoveOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/guest-remove`,
      httpMethod: "POST",
      options,
    })) as typeSquaresGuestRemoveOutput200 | typeSquaresGuestRemoveOutput400;
  };
}
